export const httpMethods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  patch: "PATCH",
  delete: "DELETE",
};

export const apiEndpoints = {
  session: "account/session/",
  refreshToken: "account/token/refresh/",
  login: "account/login/admin/",
  sendForgotPasswordOTP: "account/password/forget/otp/send/",
  verifyOTP: "account/password/forget/otp/verify/",
  resetPassword: "/account/password/reset/",
  register: "account/register/",
  address: "account/addresses/",
  bankAccount: "account/bank_account/",
  uploadBusinessDocs: "account/business/documents/",
  getUserAddresses: "account/addresses/",
  materials: "admin/material-items/",
  globalMetals: "admin/global-metal/",
  getUsers: "admin/users/",
  material: "admin/material-item/",
  subAdmin: "admin/sub-admins/",
  organization: "admin/organization/",
  organizationCurrency: "admin/organization-currency/",
  getTransactions: "admin/transactions/",
  getTransaction: "admin/transaction/",
  getBusinesses: "admin/businesses/",
  getPurchaseRequests: "admin/requests/precious-item/",
  getPurchaseRequest: "admin/requests/precious-item/",
  completeAssetRequest: "admin/requests/precious-item/complete/",
  organizationBankAccount: "admin/organization/bank-account/",
  getNotifications: "account/user/notifications/",
  readNotification: "account/user/notification/read-unread/",
  getS3PresignedURL: "generate-s3-presigned-url/",
  userSuspension: (id) => `admin/user/${id}/suspension/`,
  businessSuspension: (id) => `admin/business/${id}/suspension/`,
  bankTransferRequestConfirmation: (id) =>
    `admin/wallet/transactions/${id}/approve-reject/`,
  getStoneShapeCuts: "admin/stone-cut-shape/",
  getMetalCaratTypes: "admin/metal-carat-type/",
  getPools: "admin/pool/",
  preciousItemAttributes: "admin/precious-item/attributes/",
  getProductType: "admin/jewelry/product-type/",
  getProductColor: "admin/jewelry/product-color/",
  getMusharkaContracts: "admin/request/musharakah-contract/",
  musharkaStatusRequest: `admin/request/musharakah-contract/status/`,
  musharkaTerminateRequest: "admin/request/musharakah-contract/terminate/",
  musharkaRenewRequest: "admin/request/musharakah-contract/renew/",
  getSubscriptionPlans: "admin/subscription-plans/",
  subscriptionCreateSession: "subscription/create-session/",
  subscriptionTokenizeCard: "subscription/tokenize-card/",
  subscriptionMakePayment: "subscription/make-payment/",
  subscriptionMarkFailure: "subscription/mark-failed/",
  subscriptionInitiateTapPayment: "subscription/initiate-tap-payment/",
  subscriptionGetTapTransaction: "subscription/get-tap-transaction/",
  subscriptionTapCreateCharge: "subscription/tap/create-charge/",
  subscriptionVerifyTapPayment: "subscription/tap/verify-payment/",
  musharkaDurationChoices: "admin/musharakah-duration-choices/",
  getManufacturer: "admin/requests/manufacturing/",
  getInspectionRequests: "admin/jewelry/inspections/",
  updateInspectionStatus: (id) =>
    `admin/jewelry/product/inspections/${id}/status/`,
  getTaqabethEnforcer: "admin/taqabeth",
  getTaqabethRequests: "/admin/taqabeth-enforcer/requests/",
  getUserSubscription: "admin/business/subscription/",
  updateAdminStatus: (id) => `admin/jewelry/inspections/${id}/status/`,
  updateDeliveryStatus: (id) =>
    `admin/jewelry-production/${id}/delivery-status/`,
  updateProductComment: "admin/jewelry-production/product/",
  getInspectorRequests: "/admin/jewelry-inspector/dashboard/",
  getTerminationRequests: "/admin/request/musharakah-contract/termination/",
  updateTerminationStatus: (id) =>
    `/admin/request/musharakah-contract/termination/${id}/status/`,
  riskLevel: "admin/risk-level/",
  editRiskLevel: (id) => `/admin/business/${id}/update-risk-level/`,
  getOccupiedStocks: "/admin/taqabeth-enforcer/stocks/occupied/",
  deleteBusiness: "/admin/business/",
  getTaqabethDashboard: "/admin/taqabeth-enforcer/dashboard/",
  getOwnedAssets: "/admin/precious-items/",
  assignAssets: "/admin/purchase-request/assign-precious-item/",
  getInvestorList: "/admin/investors/",
  updateProfile: "/account/profile/",
  readUnreadNotification: "/account/user/notification/read-unread/",
  getStoneClarity: "/admin/stone-clarity/",
  getSerialNumbers: "/admin/precious-item/units/",
  getSubscriptionTransaction: "/admin/subscription-transactions/",
  getSubscriptionTransactionDetails: "/admin/subscription-transaction/",
  updatePassword: "/account/password/change/",
  updateSubscriptionPlan: "subscription/update-business-plan/",
  updateFirstApprovalStatus:
    "/admin/request/musharakah-contract/admin-approval/",
  updateMusharakahTermination: (id) =>
    `/admin/request/musharakah-contract/termination/${id}/status/`,
  updateNewMusharakah: "/admin/request/musharakah-contract/replacement/",
  getManufacturingCost: "/admin/musharakah-contract/manufacturing-cost/",
  regularTerminationRequest:
    "/admin/requests/musharakah-contracts/terminate-request/",
  updateSerialNumbers: "/admin/precious-item/units/",
  suspendUserSubscription: "/subscription/suspend-business-plan/",
  cardDetailsCreateSession: "/account/business/cards/session/",
  updateUserCardDetails: "/account/business/cards/add/",
  tapCreateAuthorize: "/account/business/cards/tap/create-authorize/",
  updatePool: (id) => `/admin/pool/contributor/${id}/update/`,
  cancelSubscription: "/subscription/cancel-business-plan/",
  getBuyerStockRequests: "/admin/jewelry-buyer/stock-management/",
  restockRequest: "/admin/jewelry-buyer/restock-requests/create/",
  deliveryRequests: "/admin/jewelry-buyer/delivery-requests/",
  publishToMarketplace: "/admin/jewelry-buyer/marketplace/publish/",
  getRestockRequest: "/admin/jewelry-buyer/restock-requests/",
  getPublishRequests: "/admin/jewelry-buyer/marketplace/",
  updateBuyerDeliveryStatus: (id) =>
    `/admin/jewelry-buyer/delivery-requests/${id}/status/`,
  recordSales: "/admin/jewelry-buyer/sales/",
  profitDistributions: "/admin/profit-distribution/",
  validateSerialNumber: "investor/precious-item-units/validate-serial-number/",
  musharakahContractMaterial: "admin/musharakah-contract-material/",
  getAvailableStocks:
    "/admin/taqabeth-enforcer/requests/precious-item/available/",
  subscriptionFreeTrial: "subscription/free-trial/activate/",
};
